// extracted by css-extract-rspack-plugin
export default {"root":"root-ot_tkr","disabled":"disabled-MwFaVT","loading":"loading-Nyyxkv","input":"input-oxqGFr"};